export default "__VITE_ASSET__D_t9ijeC__"